import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {Table} from '..';
import {openModal} from '../../actions';
import {useTableSort} from '../../utils/sortUtilities';
import Spinner from '../Spinner';

const HEAD_CELLS = [
  {
    id: 'elevatorId',
    numeric: false,
    disabledPadding: true,
    label: 'Elevator ID',
  },
  {
    id: 'elevatorName',
    numeric: false,
    disabledPadding: true,
    label: 'Elevator Name',
  },
  {
    id: 'imei',
    numeric: false,
    disabledPadding: true,
    label: 'IMEI',
  },
  {
    id: 'phoneNumber',
    numeric: false,
    disabledPadding: false,
    label: 'Phone No',
  },
  {
    id: 'buildingName',
    numeric: false,
    disabledPadding: true,
    label: 'Building Name',
  },
  {
    id: 'time',
    numeric: false,
    disabledPadding: true,
    label: 'Last Log',
  },
  {
    id: 'timePassedInSeconds',
    numeric: false,
    disabledPadding: true,
    label: 'Time Passed',
  },
];

const formatDate = (date) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(date).toLocaleDateString(undefined, options); // Customize as needed
};

const formatTime = (seconds) =>{
  const hours = Math.floor(seconds  / 3600 );
  const minutes = Math.floor((seconds % 3600) / 60);
  return `${hours}h ${minutes}m`;
}

const DATA_CELLS = ['elevatorId', 'elevatorName', 'imei', 'phoneNumber', 'buildingName', 'time', 'timePassedInSeconds'];

const InactiveElevatorsTable = ({inactiveElevators, loading, hideAddButton}) => {
  const dispatch = useDispatch();
  const tableOrder = useTableSort('asc', 'createdAt');
//   const onRowClick = item => {
    
//   };
//   const onAddEntrance = () => {
//     dispatch(openModal('AddEntranceModal', {buildingID: buildingById.id}));
//   };

  if (loading) {
    return <Spinner />;
  }

  return (
    <Table
    data={inactiveElevators.map(item => ({
      ...item,
      date: formatDate(item.date),
      timePassedInSeconds: formatTime(item.timePassedInSeconds)
    }))}
      dataCells={DATA_CELLS}
      headCells={HEAD_CELLS}
    //   onRowClick={onRowClick}
      onAdd={hideAddButton}
      noToolbar={hideAddButton}
      {...tableOrder}
      style={{ borderCollapse: 'collapse' }}
    />
  );
};

export default InactiveElevatorsTable;
